/**
 * Prepares a voucher photo for OCR.
 *
 * Tesseract slows down sharply on full-resolution phone photos, so this hands it
 * a downscaled copy. 1600px is a deliberate floor: the 800px used by the minister
 * photo pipeline blurs small print like transaction numbers, which is exactly
 * what we need to read.
 *
 * Only the OCR copy is downscaled; the original file is what gets uploaded to R2.
 */

const MAX_DIMENSION = 1600;
const JPEG_QUALITY = 0.8;

/** Returns a data URL for a downscaled JPEG copy of the file. */
export async function prepareVoucherForOcr(file: File): Promise<string> {
  const bitmap = await createImageBitmap(file);

  let { width, height } = bitmap;
  if (width > MAX_DIMENSION || height > MAX_DIMENSION) {
    if (width > height) {
      height = Math.round((height * MAX_DIMENSION) / width);
      width = MAX_DIMENSION;
    } else {
      width = Math.round((width * MAX_DIMENSION) / height);
      height = MAX_DIMENSION;
    }
  }

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('No se pudo procesar la imagen');
  ctx.drawImage(bitmap, 0, 0, width, height);
  bitmap.close();

  return canvas.toDataURL('image/jpeg', JPEG_QUALITY);
}
